import React from "react";
import { motion } from "framer-motion";
import { GALLERY } from "@/lib/api";

export default function Gallery() {
  return (
    <section id="gallery" data-testid="gallery-section" className="lk-section px-6 md:px-12 lg:px-24">
      <div className="grid md:grid-cols-12 gap-8 mb-16 items-end">
        <div className="md:col-span-6">
          <span className="text-xs uppercase tracking-[0.3em] text-[#D4AF37]">Moments</span>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light mt-4 leading-tight">
            Crafted to be
            <br />
            <span className="italic gold-gradient-text">remembered.</span>
          </h2>
        </div>
        <div className="md:col-span-5 md:col-start-8">
          <p className="text-zinc-400 leading-relaxed">
            A glimpse into the energy, elegance, and electric joy we deliver every night.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-5">
        {GALLERY.map((src, i) => (
          <motion.div
            key={src}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: i * 0.08 }}
            className={`relative overflow-hidden group ${i % 3 === 0 ? "row-span-2 aspect-[3/4]" : "aspect-square"}`}
            data-testid={`gallery-img-${i}`}
          >
            <img
              src={src}
              alt=""
              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-[1.2s]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
          </motion.div>
        ))}
      </div>
    </section>
  );
}
